/*
 * Author: Harper Yan
 * File Created: Monday, 25-03-17 10:15 am
 * Last Modified: Monday, 25-03-17 10:16 am, by Harper Yan
 */
/* eslint-disable no-unused-vars -- ignore  */

export { getOpenApiSession } from '@/src/middlewares/stores/open-api/utils';

export enum OPENAPI_POST_MESSAGE_TYPE {
  DECARD_OPENAPI_CLOSE = 'DECARD_OPENAPI_CLOSE',
  DECARD_OPENAPI_MFA_OPENED = 'DECARD_OPENAPI_MFA_OPENED',
  DECARD_OPENAPI_CARD_DETAIL_OPENED = 'DECARD_OPENAPI_CARD_DETAIL_OPENED',
}

export const postOpenAPIMessage = (
  name: OPENAPI_POST_MESSAGE_TYPE,
  payload?: Record<string, unknown>,
) => {
  window.parent.postMessage({ name, payload: payload ?? null }, '*');
};
